import ActionTypes from '../constants/ActionTypes';

/* Events */
/* Daily Report */
export const fetchDailyReportsRequested = (currentDay, interval) => ({
  type: ActionTypes.DAILY_REPORTS_FETCH_REQUESTED,
  payload: {
    currentDay,
    interval,
  },
});

export const fetchDailyReportsSucceeded = (reports) => ({
  type: ActionTypes.DAILY_REPORTS_FETCH_SUCCEEDED,
  payload: {
    reports,
  },
});

export const fetchDailyReportsFailed = (error) => ({
  type: ActionTypes.DAILY_REPORTS_FETCH_FAILED,
  payload: {
    error,
  },
});

/* Monthly Report */
export const fetchMonthlyReportsRequested = (currentMonth) => ({
  type: ActionTypes.MONTHLY_REPORTS_FETCH_REQUESTED,
  payload: {
    currentMonth,
  },
});

export const fetchMonthlyReportsSucceeded = (reports) => ({
  type: ActionTypes.MONTHLY_REPORTS_FETCH_SUCCEEDED,
  payload: {
    reports,
  },
});

export const fetchMonthlyReportsFailed = (error) => ({
  type: ActionTypes.MONTHLY_REPORTS_FETCH_FAILED,
  payload: {
    error,
  },
});

/* Yearly Report */
export const fetchYearlyReportsRequested = (currentYear) => ({
  type: ActionTypes.YEARLY_REPORTS_FETCH_REQUESTED,
  payload: {
    currentYear,
  },
});

export const fetchYearlyReportsSucceeded = (reports) => ({
  type: ActionTypes.YEARLY_REPORTS_FETCH_SUCCEEDED,
  payload: {
    reports,
  },
});

export const fetchYearlyReportsFailed = (error) => ({
  type: ActionTypes.YEARLY_REPORTS_FETCH_FAILED,
  payload: {
    error,
  },
});
